/*
  DSO will handle UI groups, using the key prop of exported object. Ensure that it is plural.
*/
export const areaChartMembers: Object = {
  'area-charts': [],
};
